import type { RouteRecordRaw } from 'vue-router'
import { RouterView } from 'vue-router'

export const accountsRoutes: RouteRecordRaw[] = [
  {
    path: '/accounts',
    name: 'accounts',
    component: RouterView,
    redirect: { name: 'dashboard' },
    meta: {
      title: 'routes.accounts',
      requiresAuth: true,
      breadcrumb: 'Accounts'
    },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../dashboard/accountsDashboard.vue'),
        meta: {
          title: 'routes.dashboard',
          requiresAuth: true,
          breadcrumb: 'Dashboard'
        }
      },
      {
        path: 'companies',
        name: 'companies',
        component: () => import('../companyMaster/components/CompanyMasterList.vue'),
        meta: {
          title: 'routes.companies',
          requiresAuth: true,
          breadcrumb: 'Companies'
        }
      },
      {
        path: 'companies/add',
        name: 'addCompany',
        component: () => import('../companyMaster/components/CompanyMasterCreation.vue'),
        meta: {
          title: 'routes.addCompany',
          requiresAuth: true,
          breadcrumb: 'Add Company'
        }
      },
     
      {
        path: 'companies/:id/edit',
        name: 'editCompany',
        component: () => import('../companyMaster/components/CompanyMasterCreation.vue'),
        props: true,
        meta: {
          title: 'routes.editCompany',
          requiresAuth: true,
          breadcrumb: 'Edit Company'
        }
      },

      // New Group Creation Route
      {
        path: 'accountshead',
        name: 'accountshead',
        component: () => import('../HeadMaster/components/HeadMasterTable.vue'),
        meta: {
          title: 'routes.groups',
          requiresAuth: true,
          permission: 'accounts.groups.view',
          breadcrumb: 'Groups'
        }
      },
      {
        path: 'accountshead-new',
        name: 'accountsheadNew',
        component: () => import('../HeadMaster/components/HeadMasterCreation.vue'),
        meta: {
          title: 'New Group Creation',
          requiresAuth: false,
          permission: 'accounts.groups.create',
          breadcrumb: 'New Group Creation'
        }
      },
      {
        path: 'accountshead-new/:id',
        name: 'accountsheadNewEdit',
        component: () => import('../HeadMaster/components/HeadMasterCreation.vue'),
        props: true,
        meta: {
          title: 'Edit Group (New)',
          requiresAuth: false,
          permission: 'accounts.groups.edit',
          breadcrumb: 'Edit Group (New)'
        }
      },
      {
        path: 'groups',
        name: 'groups',
        component: () => import('../GroupMaster/components/GroupList.vue'),
        meta: {
          title: 'routes.subgroup',
          requiresAuth: true,
          permission: 'accounts.subgroup.view',
          breadcrumb: 'SubGroup'
        }
      },
      {
        path: 'group-creation-new',
        name: 'group-creation',
        component: () => import('../HeadMaster/components/HeadMasterCreation.vue'),
        meta: {
          title: 'New SubGroup Creation',
          requiresAuth: true,
          permission: 'accounts.subgroup.create',
          breadcrumb: 'New SubGroup Creation'
        }
      },
      {
        path: 'group-creation-new/:id',
        name: 'groupCreationNewEdit',
        component: () => import('../HeadMaster/components/HeadMasterCreation.vue'),
        props: true,
        meta: {
          title: 'Edit SubGroup',
          requiresAuth: true,
          permission: 'accounts.subgroup.edit',
          breadcrumb: 'Edit SubGroup'
        }
      },
       {
        path: 'subgroup-creation',
        name: 'subgroup-creation',
        component: () => import('../GroupMaster/components/GroupCreation.vue'),
         props: true,
        meta: {
          title: 'SubGroup Creation',
          requiresAuth: true,
          permission: 'accounts.subgroup.edit',
          breadcrumb: 'New SubGroup Creation'
        }
      },
      {
        path: 'subgroup-creation/:id',
        name: 'subgroup-creation-edit',
        component: () => import('../GroupMaster/components/GroupCreation.vue'),
         props: true,
        meta: {
          title: 'Edit SubGroup',
          requiresAuth: true,
          permission: 'accounts.subgroup.edit',
          breadcrumb: 'Edit SubGroup'
        }
      },
      {
        path: 'groups-creation',
        name: 'groups-creation',
        component: () => import('../GroupMaster/components/GroupCreation.vue'),
         props: true,
        meta: {
          title: 'SubGroup Creation',
          requiresAuth: true,
          permission: 'accounts.subgroup.edit',
          breadcrumb: 'New SubGroup Creation'
        }
      },

      // Ledger Management Routes
      {
        path: 'ledger',
        name: 'ledger',
        component: () => import('../ledger/components/LedgerList.vue'),
        meta: {
          title: 'routes.ledger',
          requiresAuth: true,
          permission: 'accounts.ledger.view',
          breadcrumb: 'Ledger'
        }
      },
      {
        path: '/ledgerDetails',
        name: 'ledgerDetails',
        component: () => import('../ledger/components/LedgerDetails.vue'),
        // props: true,
        meta: {
          title: 'Ledger Details',
          requiresAuth: true,
          permission: 'accounts.ledger.view',
          breadcrumb: 'Ledger Details'
        }
      },
      {
        path: 'ledger-creation',
        name: 'ledgerCreation',
        component: () => import('../ledger/components/LedgerCreation.vue'),
        meta: {
          title: 'New Ledger Creation',
          requiresAuth: true,
          permission: 'accounts.ledger.create',
          breadcrumb: 'New Ledger Creation'
        }
      },
      {
        path: 'ledger-creation/:id',
        name: 'ledgerCreationEdit',
        component: () => import('../ledger/components/LedgerCreation.vue'),
        props: true,
        meta: {
          title: 'Edit Ledger',
          requiresAuth: true,
          permission: 'accounts.ledger.edit',
          breadcrumb: 'Edit Ledger'
        }
      },
      // SubLedger Management Routes
      {
        path: 'subledger',
        name: 'subledger',
        component: () => import('../subledger/components/SubLedgerList.vue'),
        meta: {
          title: 'routes.subledger',
          requiresAuth: true,
          permission: 'accounts.subledger.view',
          breadcrumb: 'SubLedger'
        }
      },
      {
        path: 'subledger-creation',
        name: 'subledgerCreation',
        component: () => import('../subledger/components/SubLedgerCreation.vue'),
        meta: {
          title: 'New SubLedger Creation',
          requiresAuth: true,
          permission: 'accounts.subledger.create',
          breadcrumb: 'New SubLedger Creation'
        }
      },
      {
        path: 'subledger-creation/:id',
        name: 'subledgerCreationEdit',
        component: () => import('../subledger/components/SubLedgerCreation.vue'),
        props: true,
        meta: {
          title: 'Edit SubLedger',
          requiresAuth: true,
          permission: 'accounts.subledger.edit',
          breadcrumb: 'Edit SubLedger'
        }
      },
      // Accounts Integration — pull Inventory / Billing / HMS documents and post them
      {
        path: 'integration',
        name: 'accountsIntegration',
        component: () => import('../integration/components/AccountsIntegrationView.vue'),
        meta: {
          title: 'Send to Accounts',
          requiresAuth: true,
          breadcrumb: 'Send to Accounts'
        }
      },
      // VoucherType Management Routes
      {
        path: 'voucher-type',
        name: 'voucherType',
        component: () => import('../voucherType/components/VoucherTypeList.vue'),
        meta: {
          title: 'routes.voucherType',
          requiresAuth: true,
          permission: 'accounts.voucherType.view',
          breadcrumb: 'Voucher Type'
        }
      },
      // Financial Year Management Routes
      {
        path: 'financial-year',
        name: 'financialYear',
        component: () => import('../financialYear/components/FinancialYearList.vue'),
        meta: {
          title: 'routes.financialYear',
          requiresAuth: true,
          permission: 'accounts.financialYear.view',
          breadcrumb: 'Financial Year'
        }
      },
      // Cost Centre Management Routes
      {
        path: 'cost-center',
        name: 'costCenter',
        component: () => import('../costCenter/components/CostCenterList.vue'),
        meta: {
          title: 'routes.costCenter',
          requiresAuth: true,
          permission: 'accounts.costCenter.view',
          breadcrumb: 'Cost Centre'
        }
      },
      // Currency Management Routes
      {
        path: 'currency',
        name: 'currency',
        component: () => import('../currency/components/CurrencyList.vue'),
        meta: {
          title: 'routes.currency',
          requiresAuth: true,
          permission: 'accounts.currency.view',
          breadcrumb: 'Currency Master'
        }
      },
      {
        path: 'currency-creation',
        name: 'currencyCreation',
        component: () => import('../currency/components/CurrencyCreation.vue'),
        meta: {
          title: 'Add Currency',
          requiresAuth: true,
          permission: 'accounts.currency.create',
          breadcrumb: 'Add Currency'
        }
      },
      {
        path: 'currency-creation/:id',
        name: 'currencyCreationEdit',
        component: () => import('../currency/components/CurrencyCreation.vue'),
        props: true,
        meta: {
          title: 'Edit Currency',
          requiresAuth: true,
          permission: 'accounts.currency.edit',
          breadcrumb: 'Edit Currency'
        }
      },
      // Exchange Rate Management Routes
      {
        path: 'exchange-rate',
        name: 'exchangeRate',
        component: () => import('../currency/components/ExchangeRateList.vue'),
        meta: {
          title: 'routes.exchangeRate',
          requiresAuth: true,
          permission: 'accounts.exchangeRate.view',
          breadcrumb: 'Exchange Rate Management'
        }
      },
      {
        path: 'exchange-rate-creation',
        name: 'exchangeRateCreation',
        component: () => import('../currency/components/ExchangeRateCreation.vue'),
        meta: {
          title: 'Add Exchange Rate',
          requiresAuth: true,
          permission: 'accounts.exchangeRate.create',
          breadcrumb: 'Add Exchange Rate'
        }
      },
      {
        path: 'exchange-rate-creation/:id',
        name: 'exchangeRateCreationEdit',
        component: () => import('../currency/components/ExchangeRateCreation.vue'),
        props: true,
        meta: {
          title: 'Edit Exchange Rate',
          requiresAuth: true,
          permission: 'accounts.exchangeRate.edit',
          breadcrumb: 'Edit Exchange Rate'
        }
      },
      // Exchange Rate History Route
      {
        path: 'exchange-rate-history',
        name: 'exchangeRateHistory',
        component: () => import('../currency/components/ExchangeRateHistory.vue'),
        meta: {
          title: 'Exchange Rate History',
          requiresAuth: true,
          permission: 'accounts.exchangeRate.view',
          breadcrumb: 'Exchange Rate History'
        }
      },

      {
        path: '/accounts/costcentre-mapping',
        name: 'CostCenterMapping',
        component: () => import('../costCenterMapping/components/CostCenterMappingList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Cost Centre Mapping',
          breadcrumb: [
            { text: 'Accounts', to: '/accounts' },
            { text: 'Cost Centre Mapping', active: true }
          ],
          permissions: ['accounts.costCenterMapping.view']
        }
      },
      {
        path: '/accounts/financial-year/:id/period-end-checklist',
        name: 'period-end-checklist',
        component: () => import('../periodEndChecklist/components/PeriodEndChecklist.vue'),
        meta: {
          title: 'Period End Checklist',
          requiresAuth: true,
          permissions: ['Accounts.FinancialYear.View']
        }
      },
      {
        path: 'tax-types',
        name: 'tax-types',
        component: () => import('../taxType/components/TaxTypeList.vue'),
        meta: {
          title: 'Tax Types',
          requiresAuth: true,
          permissions: ['View_TaxType']
        }
      },
      {
        path: 'tax-masters',
        name: 'tax-masters',
        component: () => import('../taxMaster/components/TaxMasterList.vue'),
        meta: {
          title: 'Tax Masters',
          requiresAuth: true,
          permissions: ['View_TaxMaster']
        }
      },
      {
        path: 'tax-components',
        name: 'tax-components',
        component: () => import('../taxComponent/components/TaxComponentList.vue'),
        meta: {
          title: 'Tax Components',
          requiresAuth: true,
          permissions: ['View_TaxComponent']
        }
      },
      // Ledger Type Master Routes
      {
        path: 'ledger-type',
        name: 'ledgerType',
        component: () => import('../ledgertype/components/LedgerTypeList.vue'),
        meta: {
          title: 'routes.ledgerType',
          requiresAuth: true,
          permission: 'accounts.ledgerType.view',
          breadcrumb: 'Ledger Type Master'
        }
      },
      // HSN Master Routes
      {
        path: 'hsn',
        name: 'hsn',
        component: () => import('../hsn/components/HSNList.vue'),
        meta: {
          title: 'routes.hsn',
          requiresAuth: true,
          permission: 'accounts.hsn.view',
          breadcrumb: 'HSN Master'
        }
      },
      // Unit Master Routes
      {
        path: 'unit',
        name: 'unit',
        component: () => import('../unit/components/UnitList.vue'),
        meta: {
          title: 'routes.unit',
          requiresAuth: true,
          permission: 'accounts.unit.view',
          breadcrumb: 'Unit Master'
        }
      },
      // Bank Master Routes
      {
        path: 'bank-master',
        name: 'bankMaster',
        component: () => import('../bankMaster/components/BankMasterList.vue'),
        meta: {
          title: 'routes.bankMaster',
          requiresAuth: true,
          permission: 'accounts.bankMaster.view',
          breadcrumb: 'Bank Master'
        }
      },
      {
        path: 'bank-master/BankMasterCreation',
        name: 'BankMasterCreation',
        component: () => import('../bankMaster/components/BankMasterPopup.vue'),
        meta: {
          title: 'Bank Master Creation',
          requiresAuth: true,
          permission: 'accounts.bankMaster.view',
          breadcrumb: 'Bank Master Creation'
        }
      },
       
      //Cheque Book
      {
        path: 'cheque-master',
        name: 'chequeMaster',
        component: () => import('../chequeMaster/components/ChequeBookMasterList.vue'),
        meta: {
          title: 'routes.chequeMaster',
          requiresAuth: true,
          permission: 'accounts.chequeMaster.view',
          breadcrumb: 'Cheque Master'
        }
      },
      // Cheque Print Template Routes 
      {
        path: 'chequeprint-template-list',
        name: 'chequePrintTemplateList',
        component: () => import('../chequePrintTemplate/components/ChequePrintTemplateList.vue'),
        
        meta: {
          title: 'Cheque Print Template',
          requiresAuth: true,
          permission: 'accounts.chequePrintTemplate.view',
          breadcrumb: 'Cheque Print Template'
        }
      },
      {
        path: 'chequeprint-template-creation',
        name: 'chequePrintTemplateCreation',
        component: () => import('../chequePrintTemplate/components/ChequePrintTemplateCreation.vue'),
        meta: {
          title: 'Create Cheque Print Template',
          requiresAuth: true,
          permission: 'accounts.chequePrintTemplate.create',
          breadcrumb: 'Create Template'
        }
      },
      {
        path: 'cheque-print-template-creation/:id',
        name: 'chequePrintTemplateEdit',
        component: () => import('../chequePrintTemplate/components/ChequePrintTemplateCreation.vue'),
        props: true,
        meta: {
          title: 'Edit Cheque Print Template',
          requiresAuth: true,
          permission: 'accounts.chequePrintTemplate.edit',
          breadcrumb: 'Edit Template'
        }
      },
      // Cheque Configuration Routes
      {
        path: 'cheque-configuration',
        name: 'chequeConfiguration',
        component: () => import('../Transaction/Cheque Configuration/components/ChequeMainScreen.vue'),
        meta: {
          title: 'Cheque Configuration',
          requiresAuth: true,
          permission: 'accounts.cheque.view',
          breadcrumb: 'Cheque Configuration'
        }
      },
      {
        path: 'cheque-configuration/book-manager',
        name: 'chequeBookManager',
        component: () => import('../Transaction/Cheque Configuration/components/ChequeBookManager.vue'),
        meta: {
          title: 'Cheque Book Manager',
          requiresAuth: true,
          permission: 'accounts.cheque.manage',
          breadcrumb: 'Cheque Book Manager'
        }
      },
      {
        path: 'cheque-configuration/account-selector',
        name: 'chequeAccountSelector',
        component: () => import('../Transaction/Cheque Configuration/components/AccountSelector.vue'),
        meta: {
          title: 'Account Management',
          requiresAuth: true,
          permission: 'accounts.cheque.accounts',
          breadcrumb: 'Account Management'
        }
      },
      {
        path: 'cheque-configuration/print-history',
        name: 'chequePrintHistory',
        component: () => import('../Transaction/Cheque Configuration/components/PrintHistory.vue'),
        meta: {
          title: 'Print History',
          requiresAuth: true,
          permission: 'accounts.cheque.history',
          breadcrumb: 'Print History'
        }
      },
      {
        path: 'cheque-configuration/settings',
        name: 'chequeSettings',
        component: () => import('../Transaction/Cheque Configuration/components/ChequeSettings.vue'),
        meta: {
          title: 'Cheque Settings',
          requiresAuth: true,
          permission: 'accounts.cheque.settings',
          breadcrumb: 'Cheque Settings'
        }
      },
      {
        path: 'tax-dashboard',
        name: 'TaxDashboard',
        component: () => import('../TaxDashboard/components/TaxDashboardView.vue'),
        meta: {
          title: 'Tax Management Dashboard',
          requiresAuth: true
        }
      },
      {
        path: 'tax-return-validation',
        name: 'TaxReturnValidation',
        component: () => import('../TaxDashboard/components/taxReturnValidation.vue'),
        meta: {
          title: 'Tax Return Validation',
          requiresAuth: true,
          permission: 'accounts.tax.validation.view',
          breadcrumb: 'Tax Return Validation'
        }
      },
      //VoucherList
      {
        path: 'VoucherList',
        name: 'Vouchers List',
        component: () => import('../Transaction/Voucher/components/VoucherList.vue'),
        meta: {
          title: 'routes.VoucherList',
          requiresAuth: true,
          permission: 'accounts.costCenter.view',
          breadcrumb: 'Cost Centre'
        }
      },
      {
        path: 'vouchertransactionlist',
        name: 'vouchertransactionlist',
        component: () => import('../Transaction/Voucher/components/VoucherTableView.vue'),
        meta: {
          title: 'routes.vouchertransactionlist',
          requiresAuth: true,
          permission: 'accounts.costCenter.view',
          breadcrumb: 'Cost Centre'
        }
      },
      {
        path: 'reports',
        name: 'Reports',
        component: () => import('../Transaction/Reports/components/reports.vue'),
        meta: {
          title: 'Reports',
          requiresAuth: true
        }
      },
      {
        path: 'reports/trial-balance',
        name: 'trialBalance',
        component: () => import('../Transaction/Reports/components/trialBalance.vue'),
        meta: {
          title: 'Trial Balance',
          requiresAuth: true
        }
      },
      {
        path: 'reports/cash-flow',
        name: 'cashFlow',
        component: () => import('../Transaction/Reports/components/cashFlowCategories.vue'),
        meta: {
          title: 'Cash Flow',
          requiresAuth: true
        }
      },
      {
        path: 'reports/financial-analysis',
        name: 'financialAnalysis',
        component: () => import('../Transaction/Reports/components/financialAnalysis.vue'),
        meta: {
          title: 'Financial Analysis',
          requiresAuth: true
        }
      },
      {
        path: 'reports/ledger-analysis',
        name: 'ledgerAnalysis',
        component: () => import('../Transaction/Reports/components/ledgerAnalysis.vue'),
        meta: {
          title: 'Ledger Analysis',
          requiresAuth: true
        }
      },
      {
        path: 'reports/cash-flow-analysis',
        name: 'cashFlowAnalysis',
        component: () => import('../Transaction/Reports/components/cashFlowAnalysis.vue'),
        meta: {
          title: 'Cash Flow Analysis',
          requiresAuth: true
        }
      },
      {
        path: 'reports/financial-ratios',
        name: 'financialRatios',
        component: () => import('../Transaction/Reports/components/financialRatiosAnalysis.vue'),
        meta: {
          title: 'Financial Ratios Analysis',
          requiresAuth: true
        }
      },
      {
        path: 'reports/reportManagement',
        name: 'reportManagement',
        component: () => import('../Transaction/Reports/components/reportManagementDashboard.vue'),
        meta: {
          title: 'Reports Management',
          requiresAuth: true
        }
      },
      {
        path: 'reports/monthly-financial-summary',
        name: 'monthlyFinancialSummary',
        component: () => import('../Transaction/Reports/components/monthlyFinancialSummary.vue'),
        meta: {
          title: 'Monthly Financial Summary',
          requiresAuth: true
        }
      },
      {
        path: 'reports/report-configuration',
        name: 'reportConfiguration',
        component: () => import('../Transaction/Reports/components/reportConfiguration.vue'),
        meta: {
          title: 'Report Configuration',
          requiresAuth: true
        }
      },
      {
        path: 'reports/month-end-closure-status',
        name: 'monthEndClosureStatus',
        component: () => import('../Transaction/Reports/components/MonthEndClosureStatus.vue'),
        meta: {
          title: 'Month End Closure Status',
          requiresAuth: true
        }
      },
      {
        path: 'reports/financial-analysis-configuration',
        name: 'financialAnalysisConfiguration',
        component: () => import('../Transaction/Reports/components/financialAnalysisConfiguration.vue'),
        meta: {
          title: 'Financial Analysis Configuration',
          requiresAuth: true
        }
      },
      {
        path: 'reports/ratio-definition-setup',
        name: 'ratioDefinitionSetup',
        component: () => import('../Transaction/Reports/components/ratioDefinitionSetup.vue'),
        meta: {
          title: 'Ratio Definition Setup',
          requiresAuth: true
        }
      },
      {
        path: 'voucher/financial',
        name: 'FinancialVoucherEntry',
        component: () => import('../Transaction/Voucher/components/FinancialVoucherEntryScreen.vue'),
        meta: {
        title: 'Sales & Purchase Voucher',
        requiresAuth: true,
        permissions: ['view_sales_purchase_voucher']
        }
        },
      {
        path: 'voucher/sales-purchase-voucher',
        name: 'SalesAndPurchaseVoucher',
        component: () => import('../Transaction/Voucher/components/SalesandPurchasevoucher.vue'),
        meta: {
          title: 'Sales & Purchase Voucher',
          requiresAuth: true,
          permissions: ['view_sales_purchase_voucher']
        }
      },
      {
        path: 'voucher/InventoryVoucher',
        name: 'InventoryVoucherEntry',
        component: () => import('../Transaction/Voucher/components/InventoryVoucherEntryScreen.vue'),
        meta: {
          title: 'Financial Voucher Entry',
          requiresAuth: true
        }
      },
        {
        path: 'voucher/excel-import',
        name: 'VoucherExcelImport',
        component: () => import('../Transaction/Voucher/components/VoucherExcelImportScreen.vue'),
        meta: {
          title: 'Voucher Excel Import',
          requiresAuth: true,
          permission: 'accounts.voucher.import',
          breadcrumb: 'Excel Import'
        }
      },
      {
        path: 'voucher/single-upload',
        name: 'SingleVoucherUpload',
        component: () => import('../Transaction/Voucher/components/SingleVoucherUploadScreen.vue'),
        meta: {
          title: 'Single Voucher Upload',
          requiresAuth: true,
          permission: 'accounts.voucher.create',
          breadcrumb: 'Single Upload'
        }
      },
      {
        path: 'reconciliation',
        name: 'reconciliation',
        component: () => import('../Transaction/Reconciliation/components/ReconciliationList.vue'),
        meta: {
          title: 'Reconciliation',
          requiresAuth: true,
          permissions: ['VIEW_RECONCILIATION']
        }
      },
      // Budget Management Routes
      {
        path: 'budget',
        name: 'budget',
        component: () => import('../budget/components/BudgetTableView.vue'),
        meta: {
          title: 'Budget Management',
          requiresAuth: true,
          permission: 'accounts.budget.view',
          breadcrumb: 'Budget'
        }
      },
      {
        path: 'budgetTemplate',
        name: 'budgetTemplate',
        component: () => import('../budget/components/BudgetTemplateTableView.vue'),
        meta: {
          title: 'Budget Template',
          requiresAuth: true,
          permission: 'accounts.budgetTemplate.view',
          breadcrumb: 'BudgetTemplate'
        }
      },
      {
        path: 'BudgetVersionControl',
        name: 'BudgetVersionControl',
        component: () => import('../budget/components/BudgetVersionControl.vue'),
        meta: {
          title: 'Budget Version Control',
          requiresAuth: true,
          permission: 'accounts.BudgetVersionControl.view',
          breadcrumb: 'Budget Version Control'
        }
      },
      {
        path: 'BudgetApprovalsDashboard',
        name: 'BudgetApprovalsDashboard',
        component: () => import('../budget/components/BudgetApprovalsDashboard.vue'),
        meta: {
          title: 'Budget Approvals Dashboard',
          requiresAuth: true,
          permission: 'accounts.BudgetApprovalsDashboard.view',
          breadcrumb: 'Budget Approvals Dashboard'
        }
      },
      {
        path: 'BudgetDashboard',
        name: 'BudgetDashboard',
        component: () => import('../budget/components/BudgetDashboard.vue'),
        meta: {
          title: 'BudgetDashboard',
          requiresAuth: true,
          permission: 'accounts.BudgetDashboard.view',
          breadcrumb: 'BudgetDashboard'
        }
      },
      {
        path: 'budgetreallocationtransfer',
        name: 'budgetreallocationtransfer',
        component: () => import('../budget/components/BudgetReallocationTable.vue'),
        meta: {
          title: 'Budget Reallocation Transfer',
          requiresAuth: true,
          permission: 'accounts.budgetreallocationtransfer.view',
          breadcrumb: 'budgetreallocationtransfer'
        }
      },
      {
        path: 'BudgetReallocationTransfer - creation',
        name: 'BudgetReallocationTransfer',
        component: () => import('../budget/components/BudgetReallocationTransfer.vue'),
        meta: {
          title: 'BudgetReallocationTransfer',
          requiresAuth: true,
          permission: 'accounts.budgetreallocationtransfer.view',
          breadcrumb: 'budgetreallocationtransfer'
        }
      },
      {
        path: 'budget-creation',
        name: 'budgetCreation',
        component: () => import('../budget/components/BudgetCreation.vue'),
        meta: {
          title: 'New Budget Creation',
          requiresAuth: true,
          permission: 'accounts.budget.create',
          breadcrumb: 'New Budget Creation'
        }
      },
      {
        path: 'period-closure',
        name: 'BudgetPeriodClosure',
        component: () => import('../budget/components/BudgetPeriodClosure.vue'),
        meta: {
          title: 'Budget Period Closure',
          requiresAuth: true,
          permissions: ['View', 'Add', 'Edit', 'Delete']
        }
      },
      {
        path: 'budget-comparison',
        name: 'BudgetComparison',
        component: () => import('../budget/components/BudgetvsActualComparison.vue'),
        meta: {
          title: 'Budget vs Actual Comparison',
          requiresAuth: true,
          permission: 'accounts.budget.view',
          breadcrumb: 'Budget Comparison'
        }
      },
      {
        path: 'BudgetAnalysisForecasting',
        name: 'budget-analysis',
        component: () => import('../budget/components/BudgetAnalysisForecasting.vue'),
        meta: {
          title: 'Budget Analysis & Forecasting',
          requiresAuth: true
        }
      },
      {
        path: 'BudgetIntegrationSettings',
        name: 'budget-integration',
        component: () => import('../budget/components/BudgetIntegrationSettings.vue'),
        meta: {
          title: 'Budget Integration Settings',
          requiresAuth: true
        }
      },
      {
        path: 'budgetmonitoringdashboard',
        name: 'BudgetMonitoringDashboard',
        component: () => import('../budget/components/BudgetMonitoringDashboard.vue'),
        meta: {
          title: 'Budget Monitoring Dashboard',
          requiresAuth: true,
          permission: 'accounts.budget.view',
          breadcrumb: 'Budget Monitoring Dashboard'
        }
      },
      {
        path: 'BulkImportView',
        name: 'BulkImportView',
        component: () => import('../common/components/BulkImportView.vue'),
        meta: {
          title: 'BulkImportView',
          requiresAuth: true,
          permission: 'accounts.budget.view',
          breadcrumb: 'BulkImportView'
        }
      },
      {
        path: 'Vouchers Bulk Import',
        name:'VouchersBulkImport',
        component: () => import('../common/components/BulkImportView.vue'),
        meta: {
          title: 'Vouchers Bulk Import',
          requiresAuth: true,
          permission: 'accounts.vouchers.bulkimport',
          breadcrumb: 'Vouchers Bulk Import'
        }
      },
      {
        path: 'AccountReceivableDashboard',
        name: 'AccountsReceivableDashboard',
        component: () => import('../Transaction/Dashboard/components/AccountReceivableDashboard.vue'),
        meta: {
          title: 'Accounts Receivable Dashboard',
          requiresAuth: true,
          breadcrumb: 'Accounts Receivable Dashboard'
        }
      },
      {
        path: 'AccountsPayableDashboard',
        name: 'AccountsPayableDashboard',
        component: () => import('../Transaction/Dashboard/components/AccountsPayableDashboard.vue'),
        meta: {
          title: 'Accounts Payable Dashboard',
          requiresAuth: true,
          breadcrumb: 'Accounts Payable Dashboard'
        }
      },
      {
        path: 'agingReports',
        name: 'agingReports',
        component: () => import('../Transaction/Reports/components/agingReports.vue'),
        meta: {
          title: 'agingReports',
          requiresAuth: true
        },
      },
      {
        path: 'AccountsBalance',
        name: 'AccountsBalance',
        component: () => import('../Transaction/Dashboard/components/AccountsBalance.vue'),
        meta: {
          title: 'Accounts Balance',
          requiresAuth: true,
          breadcrumb: 'Accounts Balance'
        }
      },
      {
        path: 'PaymentHistory',
        name: 'PaymentHistory',
        component: () => import('../Transaction/Dashboard/components/PaymentHistory.vue'),
        meta: {
          title: 'Payment History',
          requiresAuth: true,
          breadcrumb: 'Payment History'
        }
      },
      {
        path: 'code-template',
        name: 'codeTemplate',
        component: () => import('../codeTemplate/components/CodeTempate.vue'),
        meta: {
          title: 'Code Template',
          requiresAuth: true,
          breadcrumb: 'Code Template'
        }
      },
      // Approval Management Routes
      {
        path: 'approval/entitywise',
        name: 'entitywiseApprovalTableView',
        component: () => import('../approval/components/EntitywiseApprovalTableView.vue'),
        meta: {
          title: 'Approval History',
          requiresAuth: true,
          permission: 'accounts.approval.view',
          breadcrumb: 'Approval History'
        }
      },

      // Universal Reports - BL-Focused Architecture (60-70% faster)
      {
        path: 'universal-reports',
        name: 'UniversalReports',
        component: () => import('../components/UniversalReports/UniversalReportsMain.vue'),
        meta: {
          title: 'Universal Accounting Reports',
          requiresAuth: true,
          permission: 'accounts.reports.view',
          breadcrumb: 'Universal Reports'
        }
      },
      {
        path: 'universal-reports/balance-sheet',
        name: 'UniversalBalanceSheet',
        component: () => import('../components/UniversalReports/UniversalReportsMain.vue'),
        meta: {
          title: 'Universal Balance Sheet',
          requiresAuth: true,
          permission: 'accounts.reports.view',
          breadcrumb: 'Balance Sheet'
        }
      },
      {
        path: 'universal-reports/profit-loss',
        name: 'UniversalProfitLoss',
        component: () => import('../components/UniversalReports/UniversalReportsMain.vue'),
        meta: {
          title: 'Universal Profit & Loss',
          requiresAuth: true,
          permission: 'accounts.reports.view',
          breadcrumb: 'Profit & Loss'
        }
      },
      {
        path: 'universal-reports/financial-ratios',
        name: 'UniversalFinancialRatios',
        component: () => import('../components/UniversalReports/UniversalReportsMain.vue'),
        meta: {
          title: 'Universal Financial Ratios',
          requiresAuth: true,
          permission: 'accounts.reports.view',
          breadcrumb: 'Financial Ratios'
        }
      },
      {
        path: 'universal-reports/view',
        name: 'UniversalReportView',
        component: () => import('../components/UniversalReports/UniversalReportView.vue'),
        props: true,
        meta: {
          title: 'View Universal Report',
          requiresAuth: true,
          permission: 'accounts.reports.view',
          breadcrumb: 'View Report'
        }
      },
      // {
      //   path: 'budget/:id/details',
      //   name: 'budgetDetails',
      //   component: () => import('../budget/components/BudgetDetails.vue'),
      //   props: true,
      //   meta: {
      //     title: 'Budget Details',
      //     requiresAuth: true,
      //     permission: 'accounts.budget.view',
      //     breadcrumb: 'Budget Details'
      //   }
      // }
    ]
  }
]
